import { getStore } from "./../stores/base";
import { errorMsg, msgData } from "./utils";
import { getComponentInstance } from "./event.handlers";
import { LISTENER_CMDS } from "./constants";

export function componentHandler(data, workerInstance) {
  switch (data.command) {
    case LISTENER_CMDS.COMPONENT_GET:
      return getComponent(data, workerInstance);
    case LISTENER_CMDS.COMPONENT_REFRESH:
      return refreshComponent(data, workerInstance);
    case LISTENER_CMDS.COMPONENT_HIDE:
      return hideComponent(data, workerInstance);
    case LISTENER_CMDS.COMPONENT_SHOW:
      return showComponent(data, workerInstance);
    case LISTENER_CMDS.COMPONENT_ADD_EVENT_LISTENER:
      return addComponentEventObserver(data, workerInstance);
    default:
      return handleComponentAPI(data, workerInstance);
  }
}

const getComponentMethods = async (pageId, componentId) => {
  let usePageStore = getStore(`runtime_page_${pageId}`);
  let componentMethods = await usePageStore
    .getState()
    .getComponentMethods(componentId);
  return componentMethods || [];
};

const getComponent = async (data, workerInstance) => {
  let componentMethods;
  let componentId = data.componentId;
  componentMethods = await getComponentMethods(
    workerInstance.pageId,
    componentId
  );
  getComponentInstance(data.componentId, { createOnFallback: true });
  return msgData(data, {
    componentId,
    componentMethods
  });
};

const addComponentEventObserver = (data, workerInstance) => {
  let componentInstance = getComponentInstance(data.id, {
    createOnFallback: true
  });
  componentInstance.addEventListener(
    data.eventName,
    function onMountHandler(eventParams) {
      workerInstance.postEventMessage(
        {
          target: data.id,
          eventName: data.eventName,
          eventConfig: data.eventConfig
        },
        eventParams
      );
    }
  );
};

const refreshComponent = (data, workerInstance) => {
  try {
    const { id: componentId } = data;
    let useComponentStore = getStore(`${workerInstance.pageId}/${componentId}`);
    if (!useComponentStore) {
      useComponentStore = getStore(componentId);
    }
    useComponentStore.getState().refresh();
    return msgData(data, {
      message: "refreshed component"
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

const showComponent = (data, workerInstance) => {
  try {
    const { id: componentId } = data;
    let usePageStore = getStore(`runtime_page_${workerInstance.pageId}`);
    usePageStore.getState().toggleVisibility(componentId, true);
    return msgData(data, {
      message: "component is visible"
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

const hideComponent = (data, workerInstance) => {
  try {
    const { id: componentId } = data;
    let usePageStore = getStore(`runtime_page_${workerInstance.pageId}`);
    usePageStore.getState().toggleVisibility(componentId, false);
    return msgData(data, {
      message: "component is hidden"
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

const handleComponentAPI = async (data, workerInstance) => {
  let execResp = await executeComponentAPI(data, workerInstance);
  return sendBackResponse(data, execResp);
};

const executeComponentAPI = async (data, workerInstance) => {
  let componentId = data.id;
  let pageId = workerInstance.pageId;

  // check if store is create for particular component inside page
  // if store isn't create then component is not mounted yet.
  let useComponentStore = getStore(`${pageId}/${componentId}`);
  if (!useComponentStore) {
    return { error: "component is not mounted yet" };
  }
  let methodName = data.command.split("COMPONENT_")[1];
  let componentMethods = await getComponentMethods(pageId, componentId);
  let manifestDefenition = componentMethods.find(
    (method) => method.name === methodName
  );
  // manifest Defenition has all details about the api
  // api can be of type : method and event
  let componentApi = useComponentStore.getState()[methodName];
  if (componentApi && manifestDefenition.type === "method") {
    // if api kind is a method then it would be a member in
    // store it can be executed simply invoking
    let response = componentApi(...(data.parameters || {}));
    return response;
  }
  return { error: "Error while executing component API" };
};

const sendBackResponse = (data, response, workerInstance) => {
  let messageData = {};
  if (response?.error) {
    messageData = errorMsg(data, { message: response.error });
  } else {
    messageData = msgData(data, { response });
  }
  if (workerInstance) {
    workerInstance.postMessage({ ...messageData });
    return;
  }
  return messageData;
};
